// Pattern: docs/design-patterns/frontend/api-client — service layer (no error catching)

import type { FrameworkDetail, FrameworkManifest } from '~/types';

import { apiRequest } from './client';

const FRAMEWORKS_BASE = '/frameworks';

export async function getFramework(id: string): Promise<FrameworkDetail> {
  const response = await apiRequest<FrameworkDetail>(`${FRAMEWORKS_BASE}/${id}`);
  return response.data;
}

export async function getFrameworkManifest(): Promise<FrameworkManifest> {
  const response = await apiRequest<FrameworkManifest>(`${FRAMEWORKS_BASE}/manifest`);
  return response.data;
}
